module.exports = __webpack_public_path__ + "static/media/attractive-mobile-2.fbb9b54c.jpg";